/*
 * @Description: 公共接口
 * @Author: sunxiaodong
 * @Date: 2020-07-28 15:54:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-15 15:42:13
 */

import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  E6_MS_TMS_E6YUN_BASE_WEB,
  E6_MS_TMS_BUSI_WEB,
  E6_MS_TMS_BASE_WEB
} = e6ModuleOrderWaybillProcessApi;

/************************运单管理公共接口*************************/
// 字典
export function findByDicTypeKey(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/findByDicTypeKey`,
    method: "get",
    params
  });
}

/************************运单列表相关接口*************************/
//运单列表
export function getWaybillList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/pageQueryByCondition`,
    method: "post",
    data: data
  });
}
// 运单列表-查询不同状态的运单数量
export function getWaybillNumerByCondition(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillNumberByCondition`,
    method: "post",
    data: data
  });
}
// 获取承运公司列表
export function getCarrierCorpList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCarrierByPage`,
    method: "post",
    data
  });
}
// 获取客户列表
export function getCustomerNameList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCustomerByPage`,
    method: "post",
    data
  });
}
// 获取配送区域列表
export function getDeliveryAreaList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}
// 获取主司机列表
export function getMainDriverList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/findAllDriverByPage`,
    method: "post",
    data
  });
}
// 获取设备列表
export function getTerminalList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/equip/findEquipPage`,
    method: "post",
    data
  });
}
// 获取车辆列表
export function getVehicleList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/findAllVehicles`,
    method: "post",
    data
  });
}
// 获取运单所属部门列表
export function getWaybillDepartmentList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}
// 获取运单状态列表
export function getWaybillStatusList(type) {
  return http({
    url:
      `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillStatusList?statusType=` +
      type,
    method: "get"
  });
}
// 批量删除运单
export function deleteBatchWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/batchDeleteWaybill`,
    method: "post",
    data
  });
}
// 单个删除运单
export function deleteWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/deleteWaybill`,
    method: "post",
    data
  });
}
// 获取关联订单详情
export function getOrderDeatilList(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getOrderInfoListByWaybillId`,
    method: "get",
    params
  });
}
// 自定义运单名称
export function fatchWaybillName(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/editWaybillName`,
    method: "post",
    data
  });
}
// 运单分配
export function fatchAssignDepartment(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/assignDepartment`,
    method: "post",
    data
  });
}
// 运单委派
export function fatchDelegateWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/delegateWaybill`,
    method: "post",
    data
  });
}
// 运单取消派车
export function fatchCancelVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/cancelVehicle`,
    method: "post",
    data
  });
}
// 运单接受任务
export function fatchAcceptDuties(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/receive`,
    method: "post",
    data
  });
}
// 运单拒绝任务
export function fatchRefuseDuties(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/refuse`,
    method: "post",
    data
  });
}
// 导出运单
export function exportWaybill(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/exportWaybill`,
    method: "post",
    data
  });
}
//获取运单货物信息
export function fetchWaybillGoodsDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/findGoodsListByWaybillId`,
    method: "get",
    params
  });
}

/************************运单派车相关接口*************************/

// 运单派车-查询运单详情
export function getWaybillSendDetails(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillInfoForAssignVehicle`,
    method: "get",
    params
  });
}

// 运单派车
export function fatchAssignVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/assignVehicle`,
    method: "post",
    data
  });
}

// 派车页面查询车辆信息
export function fatchQueryVehicleInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/pageQueryVehicleInfo`,
    method: "post",
    data
  });
}

/************************运单详情相关接口*************************/
// 查询基础信息、运输信息、承运订单
export function getWaybillDetailById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillDetailById`,
    method: "get",
    params
  });
}
// 查询运单事件
export function getEventListVOById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getEventListVOById`,
    method: "get",
    params
  });
}
// 查询节点信息
export function getNodeListVOById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getNodeListVOById`,
    method: "get",
    params
  });
}
// 查询运单详情扩展字段
export function findWaybillExpandById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/findWaybillExpandById`,
    method: "get",
    params
  });
}
// 运单轨迹详情
export function getWaybillTrack(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getDetailByWaybillNo`,
    method: "get",
    params
  });
}
/*************** 运单更改记录相关接口 ************* */
//获取更改记录列表
export function fetchWaybillUpdateRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillHistory/findByPage`,
    method: "post",
    data
  });
}
/*************** 运单转运相关接口 ************* */
// 查询订单信息
export function getTransferOrderList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/transfer/getTransferOrderList`,
    method: "post",
    data
  });
}
// 转运卸货
export function transferUnload(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/transfer/transferUnload`,
    method: "post",
    data
  });
}
// 转运分配
export function transferAllocate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/transfer/transferAllocate`,
    method: "post",
    data
  });
}
/*****************查询转运信息********************* */

export function getTransferInfo(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/transfer/transferInfo`,
    method: "get",
    params
  });
}
